var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.58 6.526a1.58 1.58 0 1 1-3.162 0 1.58 1.58 0 0 1 3.161 0Z",
    stroke: "#3AB44A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.999 10.177c1.904 0 3.646-1.369 4.626-3.651-.98-2.282-2.722-3.651-4.626-3.651h.002c-1.904 0-3.646 1.369-4.626 3.651.98 2.282 2.722 3.651 4.626 3.651h-.002Z",
    stroke: "#3AB44A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEye);
export default __webpack_public_path__ + "static/media/green-eye.76447b3d9d79b17faa6f7bc72ce87276.svg";
export { ForwardRef as ReactComponent };